export default (state = {}, {userId, res}: any) => {
  return {
    ...state,
    incentiveTripBonusBanner: {
      [userId]: res,
    },
  };
};
